// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .main-content {
    background-color: #f8f9fa;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .header {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .header h1 {
    color: #333;
    font-size: 24px;
    font-weight: bold;
  }
  
  .card-body {
    background-color: #fff;
    border-radius: 10px;
    padding-bottom: 20px;
    padding-top: 20px;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .table th,
  .table td {
    padding: 12px;
    border-bottom: 1px solid #dee2e6;
    text-align: left;
  }
  
  .table th {
    background-color: #f2f2f2;
    font-weight: bold;
    font-size: 16px;
  }
  
  .table tbody tr:nth-child(even) {
    background-color: #f8f9fa;
  }
  
  .active-status {
    color: #28a745;
    font-weight: bold;
  }
  
  .inactive-status {
    color: #dc3545;
    font-weight: bold;
  }
  
  .sim-status,
  .generation {
    font-weight: bold;
    font-size: 14px;
  }

  /* Container to handle truncation */
.truncated-cell {
  max-width: 200px; /* Adjust the width based on your table design */
  white-space: nowrap; /* Prevents the text from wrapping */
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  cursor: pointer;
}

/* Tooltip styling */
.truncated-cell:hover::after {
  content: attr(data-full-text); /* Use the full text from data attribute */
  position: absolute;
  left: 0;
  top: 100%;
  background: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  white-space: normal; /* Allow wrapping inside the tooltip */
  z-index: 10;
  width: max-content;
  max-width: 400px; /* Set max-width for the tooltip */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-size: 14px;
}

/* Style the search bar container */
.search-bar-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

/* Style for the search input field */
.search-bar {
  flex: 1 1;
  padding: 8px;
  font-size: 16px;
  margin-right: 20px; /* Add margin-right to create space between search bar and button */
}

/* Style for the Add Device button */
.btn-primary {
  padding: 8px 16px;
}

/* Style for the table container and no data message */
.table-container {
  margin-top: 20px;
}

.text-center {
  text-align: center;
}

/* Style for pagination container */
.pagination-container {
  margin-top: 20px;
}

/* ActiveUsersTable.css */
.container {
  margin: 20px auto;
  max-width: 1200px;
}

.main-content {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.header {
  text-align: center;
  margin-bottom: 20px;
}

.search-bar-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.search-bar {
  width: 70%;
  padding: 8px;
  border-radius: 20px;
  border: 1px solid #ddd;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  border-radius: 20px;
}

.card-body {
  padding: 0;
  border: none;
}

.brand-list {
  max-height: 70vh;
  overflow-y: auto;
}

.brand-header {
  background-color: #eaeced;
  color: #2c2c2c;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 18px;
  border-radius: 8px 8px 0 0;
}

.brand-header:hover {
  background-color: #d3d4d6;
}

.table {
  width: 100%;
  margin-bottom: 0;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
}

.table th,
.table td {
  padding: 12px;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table th {
  background-color: #f1f1f1;
}

.table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.table tbody tr:hover {
  background-color: #e9ecef;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  padding: 10px;
  background-color: #f1f1f1;
  border-radius: 0 0 8px 8px;
}

.pagination {
  margin-bottom: 0;
}

.pagination-item {
  cursor: pointer;
}

.pagination-link {
  color: #007bff;
  border-radius: 50%;
  padding: 5px 10px;
}

.pagination-link:hover {
  background-color: #0056b3;
  color: #fff;
}

.pagination-item.active .pagination-link {
  background-color: #007bff;
  color: #fff;
}

.text-center {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: #555;
}

@media (max-width: 768px) {
  .search-bar-container {
    flex-direction: column;
    align-items: center;
  }

  .search-bar {
    width: 100%;
    margin-bottom: 10px;
  }
}



  

.action-menu {
  position: relative;
  display: inline-block;

}

.action-menu-content {
  position: absolute;
  background-color: #f9f9f9;
  padding-left: 10px;
  padding-right: 10px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  min-width: 100px;
  
}

.action-menu-content p {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  cursor: pointer;
}

.action-menu-content a:hover {
  background-color: #f1f1f1;
}

.action-menu-button {
  color: black;
  border: none;
  cursor: pointer;
  text-align: right;
  margin-left: 16px;
}


`, "",{"version":3,"sources":["webpack://./src/styles/DeviceWhitelisting.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;IACb,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,mCAAmC;AACrC;EACE,gBAAgB,EAAE,gDAAgD;EAClE,mBAAmB,EAAE,oCAAoC;EACzD,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,6BAA6B,EAAE,0CAA0C;EACzE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB,EAAE,sCAAsC;EAC3D,WAAW;EACX,kBAAkB;EAClB,gBAAgB,EAAE,kCAAkC;EACpD,uCAAuC;EACvC,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,kBAAkB,EAAE,mEAAmE;AACzF;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;AACnB;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;;;;;AAMA;EACE,kBAAkB;EAClB,qBAAqB;;AAEvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,UAAU;EACV,gBAAgB;;AAElB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n  }\n  \n  .main-content {\n    background-color: #f8f9fa;\n    border-radius: 10px;\n    padding: 20px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .header {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n  .header h1 {\n    color: #333;\n    font-size: 24px;\n    font-weight: bold;\n  }\n  \n  .card-body {\n    background-color: #fff;\n    border-radius: 10px;\n    padding-bottom: 20px;\n    padding-top: 20px;\n  }\n  \n  .table-container {\n    overflow-x: auto;\n  }\n  \n  .table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .table th,\n  .table td {\n    padding: 12px;\n    border-bottom: 1px solid #dee2e6;\n    text-align: left;\n  }\n  \n  .table th {\n    background-color: #f2f2f2;\n    font-weight: bold;\n    font-size: 16px;\n  }\n  \n  .table tbody tr:nth-child(even) {\n    background-color: #f8f9fa;\n  }\n  \n  .active-status {\n    color: #28a745;\n    font-weight: bold;\n  }\n  \n  .inactive-status {\n    color: #dc3545;\n    font-weight: bold;\n  }\n  \n  .sim-status,\n  .generation {\n    font-weight: bold;\n    font-size: 14px;\n  }\n\n  /* Container to handle truncation */\n.truncated-cell {\n  max-width: 200px; /* Adjust the width based on your table design */\n  white-space: nowrap; /* Prevents the text from wrapping */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n  cursor: pointer;\n}\n\n/* Tooltip styling */\n.truncated-cell:hover::after {\n  content: attr(data-full-text); /* Use the full text from data attribute */\n  position: absolute;\n  left: 0;\n  top: 100%;\n  background: #333;\n  color: #fff;\n  padding: 5px 10px;\n  border-radius: 5px;\n  white-space: normal; /* Allow wrapping inside the tooltip */\n  z-index: 10;\n  width: max-content;\n  max-width: 400px; /* Set max-width for the tooltip */\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  font-size: 14px;\n}\n\n/* Style the search bar container */\n.search-bar-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n/* Style for the search input field */\n.search-bar {\n  flex: 1;\n  padding: 8px;\n  font-size: 16px;\n  margin-right: 20px; /* Add margin-right to create space between search bar and button */\n}\n\n/* Style for the Add Device button */\n.btn-primary {\n  padding: 8px 16px;\n}\n\n/* Style for the table container and no data message */\n.table-container {\n  margin-top: 20px;\n}\n\n.text-center {\n  text-align: center;\n}\n\n/* Style for pagination container */\n.pagination-container {\n  margin-top: 20px;\n}\n\n/* ActiveUsersTable.css */\n.container {\n  margin: 20px auto;\n  max-width: 1200px;\n}\n\n.main-content {\n  background-color: #f8f9fa;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.search-bar-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.search-bar {\n  width: 70%;\n  padding: 8px;\n  border-radius: 20px;\n  border: 1px solid #ddd;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.btn-primary {\n  background-color: #007bff;\n  border-color: #007bff;\n  border-radius: 20px;\n}\n\n.card-body {\n  padding: 0;\n  border: none;\n}\n\n.brand-list {\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.brand-header {\n  background-color: #eaeced;\n  color: #2c2c2c;\n  cursor: pointer;\n  padding: 10px 20px;\n  font-size: 18px;\n  border-radius: 8px 8px 0 0;\n}\n\n.brand-header:hover {\n  background-color: #d3d4d6;\n}\n\n.table {\n  width: 100%;\n  margin-bottom: 0;\n  background-color: #fff;\n  border-radius: 0 0 8px 8px;\n}\n\n.table th,\n.table td {\n  padding: 12px;\n  vertical-align: top;\n  border-top: 1px solid #dee2e6;\n}\n\n.table th {\n  background-color: #f1f1f1;\n}\n\n.table tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.table tbody tr:hover {\n  background-color: #e9ecef;\n}\n\n.pagination-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 15px;\n  padding: 10px;\n  background-color: #f1f1f1;\n  border-radius: 0 0 8px 8px;\n}\n\n.pagination {\n  margin-bottom: 0;\n}\n\n.pagination-item {\n  cursor: pointer;\n}\n\n.pagination-link {\n  color: #007bff;\n  border-radius: 50%;\n  padding: 5px 10px;\n}\n\n.pagination-link:hover {\n  background-color: #0056b3;\n  color: #fff;\n}\n\n.pagination-item.active .pagination-link {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.text-center {\n  text-align: center;\n  padding: 20px;\n  font-size: 16px;\n  color: #555;\n}\n\n@media (max-width: 768px) {\n  .search-bar-container {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .search-bar {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n}\n\n\n\n  \n\n.action-menu {\n  position: relative;\n  display: inline-block;\n\n}\n\n.action-menu-content {\n  position: absolute;\n  background-color: #f9f9f9;\n  padding-left: 10px;\n  padding-right: 10px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  min-width: 100px;\n  \n}\n\n.action-menu-content p {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n  cursor: pointer;\n}\n\n.action-menu-content a:hover {\n  background-color: #f1f1f1;\n}\n\n.action-menu-button {\n  color: black;\n  border: none;\n  cursor: pointer;\n  text-align: right;\n  margin-left: 16px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
